import {
  BoletoActionTypes,
  setBoletos,
  setBoletosSummary,
  setLoading,
  setLoadingSummary,
} from 'store/reducers/ticket.reducer';
import handleError from 'utils/handleError';
import Notification from 'utils/notifications';
import { ticketSortFieldMap } from 'utils/functions';

const { all, call, put, select, debounce, takeLatest } = require('redux-saga/effects');
import { getBoletos, getBoletosSummary } from 'utils/web-api';

function* asyncFetchBoletos({ payload }) {
  const { page, pageSize, status, search, sort, orderBy, dateFrom, dateTo } = payload || {};
  try {
    yield put(setLoading(true));
    const token = yield select(state => state.Auth.token);

    const apiSort   = ticketSortFieldMap[sort] || 'created_at';
    const apiOrder  = String(orderBy || 'DESC').toUpperCase();

    const response = yield call(
      () => getBoletos(token, page, pageSize, status, search, apiSort, apiOrder, dateFrom, dateTo)
    );

    yield put(setBoletos(response || { items: [], total: 0 }));
  } catch (error) {
    handleError(error);
    Notification('error', 'Erro ao carregar os boletos.');
    yield put(setBoletos({ items: [], total: 0 }));
  } finally {
    yield put(setLoading(false));
  }
}

function* asyncFetchBoletosSummary({ payload }) {
  const { dateFrom, dateTo, search } = payload || {};
  try {
    yield put(setLoadingSummary(true));
    const token = yield select((state) => state.Auth.token);

    const resp = yield call(() => getBoletosSummary(token, dateFrom, dateTo, search));

    const summary = {
      generated: resp?.total_generated_bills ?? 0,
      overdue:   resp?.total_overdue_bills   ?? 0,
      paid:      resp?.total_paid_bills      ?? 0,
      totalGenerated: resp?.total_amount_generated_bills ?? 0,
      totalOverdue:   resp?.total_amount_overdue_bills   ?? 0,
      totalPaid:      resp?.total_amount_paid_bills      ?? 0,
    };

    yield put(setBoletosSummary(summary));
  } catch (error) {
    handleError(error);
    Notification('error', 'Erro ao carregar o resumo de boletos.');
    yield put(setBoletosSummary({ generated: 0, overdue: 0, paid: 0 }));
  } finally {
    yield put(setLoadingSummary(false));
  }
}

export default function* MySaga() {
  yield all([
    yield debounce(500, BoletoActionTypes.ASYNC_BOLETOS, asyncFetchBoletos),
    yield takeLatest(BoletoActionTypes.ASYNC_BOLETOS_SUMMARY, asyncFetchBoletosSummary),
  ]);
}
